import {Component, input} from '@angular/core';
import {DirectusTranslation} from '@frontend/directus';
import {DirectusTooltipComponent} from '../directus-tooltip/directus-tooltip.component';
import {TranslateDirectusPipe} from '@frontend/transloco';

@Component({
  selector: 'app-module-function-label',
  imports: [DirectusTooltipComponent, TranslateDirectusPipe],
  templateUrl: './module-function-label.component.html',
  host: {class: 'block min-w-0'},
})
export class ModuleFunctionLabelComponent {
  translations = input.required<DirectusTranslation[]>();
  /** When true the label wraps to multiple lines instead of truncating with an ellipsis. */
  readonly wrap = input(false);
}
